<template>
  <div>
    <Form ref="searchForm" :model="form" inline style="margin:10px 0 0 0;">
      <FormItem class="fr">
        <Button type="primary" @click="searFn">搜索</Button>
      </FormItem>
      <FormItem v-for="(item, index) in searchList" :key="index">
        <FormItem>
          <Select v-model="item.value.modal" style="width:180px">
            <Option
              v-for="item in modalList"
              :value="item.value"
              :key="item.id"
              >{{ item.value }}</Option
            >
          </Select>
        </FormItem>
        <FormItem>
          <Select v-model="item.value.formula" style="width:100px">
            <Option
              v-for="(item, index) in formulaList"
              :value="item.value"
              :key="index"
              >{{ item.value }}</Option
            >
          </Select>
        </FormItem>
        <FormItem>
          <Input
            type="text"
            style="width:100px;"
            v-model="item.value.value"
            placeholder="输入内容"
          />
        </FormItem>

        <FormItem
          >则
          <Select v-model="item.value.state" style="width:70px">
            <Option
              v-for="(item, index) in statelist"
              :value="item.value"
              :key="index"
              >{{ item.value }}</Option
            >
          </Select>
        </FormItem>
        <FormItem v-if="index == 0" style="margin:4px 0 0 0;">
          <Icon type="ios-add-circle-outline" size="24" @click="addFn" />
        </FormItem>
        <FormItem v-else style="margin:4px 0 0 0;">
          <Icon
            type="ios-remove-circle-outline"
            size="24"
            @click="delFn(index)"
          />
        </FormItem>
      </FormItem>
    </Form>
    <div class="testCon pr">
      <Table
        stripe
        row-key="id"
        border
        resizable
        :columns="columns"
        height="454"
        :data="newProcessLog"
      >
        <template slot-scope="{ row, index }" slot="modal">
          <span v-if="$MethodFn.getType(row.hash) != ''">{{
            $MethodFn.getType(row.hash)[0]
          }}</span>
        </template>
        <template slot-scope="{ row, index }" slot="add">
          <span
            v-if="
              $MethodFn.getType(row.hash) != '' &&
                $MethodFn.getType(row.hash).length > 1
            "
            >{{ $MethodFn.getType(row.hash)[1] }}</span
          >
        </template>
        <template slot-scope="{ row, index }" slot="subid">
          <strong v-if="row.subid == 31">文件打开/创建操作</strong>
          <strong v-if="row.subid == 32">文件读操作</strong>
          <strong v-if="row.subid == 33">映射读操作</strong>
          <strong v-if="row.subid == 34">文件写操作</strong>
          <strong v-if="row.subid == 35">文件删除</strong>
          <strong v-if="row.subid == 36">文件重命名</strong>
        </template>
      </Table>
      <div class="scrollbar" ref="scrollbar">
        <div ref="inScrollbar" :style="{ height: scrollHeight }"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['fileLog'],
  data() {
    return {
      dataCount: 0,
      // 每页显示多少条
      pageSize: 10,
      // 当前页码
      page: 1,
      // 表格头部信息
      tableColumns1: [
        {
          title: '人员',
          key: 'username',
        },
      ],
      scrollHeight: 0,
      scrollbarTop: '',
      tableData1: [],
      searchList: [
        {
          value: {
            modal: '',
            formula: '',
            value: '',
            state: '',
          },
          index: 1,
        },
      ],
      statelist: [
        {
          value: '显示',
        },
        {
          value: '隐藏',
        },
      ],
      formulaList: [
        {
          value: '等于',
        },
        {
          value: '不等于',
        },
        {
          value: '开始于',
        },
        {
          value: '结束于',
        },
        {
          value: '包含',
        },
        {
          value: '不包含',
        },
      ],
      modalList: [
        {
          id: 1,
          value: '进程ID',
        },
        {
          id: 2,
          value: '线程ID',
        },
        {
          id: 3,
          value: '线程所在路径',
        },
        {
          id: 4,
          value: '线程所在模块',
        },
        {
          id: 5,
          value: '时间',
        },
        {
          id: 6,
          value: '操作类型',
        },
        {
          id: 7,
          value: '目标文件',
        },
      ],
      form: {
        barId: '',
      },
      columns: [
        {
          title: '进程ID',
          key: 'ppid',
          sortable: true,
          align: 'center',
          tree: true,
          tooltip: true,
          width: 120,
          resizable: true,
        },
        {
          title: '线程ID',
          key: 'pid',
          sortable: true,
          align: 'center',
          tree: true,
          tooltip: true,
          width: 120,
          resizable: true,
        },
        {
          title: '进程所在路径',
          key: 'path',
          sortable: true,
          tree: true,
          tooltip: true,
          resizable: true,
        },

        {
          title: '线程所属模块',
          slot: 'modal',
          sortable: true,
          align: 'center',
          tree: true,
          tooltip: true,
          resizable: true,
        },
        {
          title: '线程地址',
          slot: 'add',
          tree: true,
          tooltip: true,
          resizable: true,
        },
        {
          title: '时间',
          key: 'time',
          sortable: true,
          align: 'center',
          tree: true,
          tooltip: true,
          resizable: true,
        },
        {
          title: '操作类型',
          sortable: true,
          align: 'center',
          tree: true,
          slot: 'subid',
          tooltip: true,
          width: 160,
          resizable: true,
        },
        {
          title: '目标文件',
          key: 'cmd',
          sortable: true,
          tree: true,
          tooltip: true,
          resizable: true,
        },
      ],
      dataSource: [],
      newProcessLog: [],
      size: 13,
    }
  },
  watch: {
    fileLog() {
      this.getData()
    },
  },
  mounted() {
    this.$refs.scrollbar.addEventListener(
      'scroll',
      (e) => {
        this.scrollbarTop = this.$refs.scrollbar.scrollTop
        this.getData()
      },
      false
    )
    this.getData()
  },
  methods: {
    findall(a, x) {
      let result = []
      a.forEach((element, index) => {
        console.log(x)
        if (element.ppid == x) {
          result.push(index)
        }
      })
      return result
    },
    searFn() {
      console.log(111)
      if (this.searchList != '') {
        // let index = this.fileLog.findIndex(
        //   (item) => item.ppid ==
        // )
        let newData = [...this.fileLog]
        console.log(this.findall(newData, this.searchList[0].value.value))
      }
    },
    getData() {
      this.newProcessLog = []
      this.scrollHeight = this.fileLog.length * 32 + 'px'
      let newData = [...this.fileLog]
      let index = Number(this.scrollbarTop) / 32
      if (newData.length <= this.size) {
        this.newProcessLog = newData.slice(0, this.size)
      } else {
        let len
        if (Number(parseInt(index)) + this.size > newData.length) {
          len = newData.length
        } else {
          len = Number(parseInt(index)) + this.size
        }
        this.newProcessLog = newData.slice(Number(parseInt(index)), len)
      }
    },
    handleListApproveHistory() {
      // 保存取到的所有数据
      this.dataCount = this.$store.state.log.fileLog.length
      // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
      if (this.$store.state.log.fileLog.length < this.pageSize) {
        this.tableData1 = this.$store.state.log.fileLog
      } else {
        this.tableData1 = this.$store.state.log.fileLog.slice(0, this.pageSize)
      }
    },
    addFn() {
      this.index++
      this.searchList.push({
        value: {
          modal: '',
          formula: '',
          value: '',
          state: '',
        },
        index: this.index,
      })
    },
    delFn(val) {
      this.searchList.splice(val, 1)
    },
  },
}
</script>
<style lang="scss" scoped>
.scrollbar {
  height: 454px;
  width: 30px;
  right: 0px;
  position: absolute;
  overflow: auto;
  top: 0;
}
</style>
